
import router from '@/router'
import i18n from '@/commons/translations/i18n'
import ModalBox from '@/commons/components/modal-box/ModalBox.vue'
import { Component, Vue } from 'vue-property-decorator'
import ModalBoxUntrustedAuthenticationContent from '@/commons/components/modal-box/ModalBoxUntrustedAuthenticationContent.vue'

@Component({
    components: {
        ModalBox
    }
})
export default class ModalBoxUntrustedAuthentication extends Vue {
    modalBoxBodyInstance (): Vue {
        return new ModalBoxUntrustedAuthenticationContent(
            {
                name: 'untrustedAuthentication',
                i18n: i18n,
                router: router
            }
        )
    }
}
